import { Box, SvgIcon, Typography } from "@mui/material";

import { WindIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

import { StatCard } from "../components/StatCard";
import { isDefined } from "utils/common";

type AirQualityTextProps = {
  value: number;
};

function AirQualityText({ value }: AirQualityTextProps) {
  const { t } = useTranslation();

  const x = Math.round(value);

  switch (true) {
    case x === 0:
      return "-";
    case x <= 50 && x >= 0:
      return t("Great");
    case x <= 100:
      return t("Good");
    case x <= 150:
      return t("Fair");
    case x <= 200:
      return t("Poor");
    case x <= 250:
      return t("Bad");
    case x <= 350:
      return t("Very Bad");
    case x <= 500:
      return t("Extremely Bad");
    default:
      return "-";
  }
}

type AirCardProps = {
  airQuality?: number | null;
  humidity?: number | null;
};

export function AirCard({ airQuality, humidity }: AirCardProps) {
  const { t } = useTranslation();

  if (!isDefined(airQuality) && !isDefined(humidity)) {
    return null;
  }

  return (
    <StatCard>
      <SvgIcon component={WindIcon} color={"neutral.decoration"} />
      <Box>
        {isDefined(airQuality) && (
          <>
            <Typography
              variant={"bodySmallMedium"}
              sx={{
                color: "neutral.subtle",
              }}
            >
              {t("Air Quality")}
            </Typography>
            <Typography
              variant={"bodyLargeMedium"}
              sx={{
                marginBottom: 1.5,
              }}
            >
              <AirQualityText value={airQuality} />
            </Typography>
          </>
        )}
        {isDefined(humidity) && (
          <>
            <Typography
              variant={"bodySmallMedium"}
              sx={{
                color: "neutral.subtle",
              }}
            >
              {t("Humidity")}
            </Typography>
            <Typography variant={"bodyLargeMedium"}>
              {humidity.toFixed(0)}%
            </Typography>
          </>
        )}
      </Box>
    </StatCard>
  );
}
